import { Link } from '@tanstack/react-router'
import { Wallet } from 'lucide-react'

export function CreditBadge({ balance, to }: { balance?: number; to: string }) {
  if (balance === undefined) return null

  return (
    <Link
      to={to}
      className="relative flex size-9 items-center justify-center rounded-lg text-muted-foreground transition-colors hover:bg-card hover:text-foreground"
    >
      <Wallet className="size-4" />
      <span className="absolute -top-0.5 -right-0.5 flex size-4 items-center justify-center rounded-full bg-[#f97316] text-[10px] font-bold text-white">
        {balance}
      </span>
    </Link>
  )
}
